import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronRight, MapPin } from "lucide-react";

export const ExpCard = ({ data, setHovered }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className="border-b border-gray-200 last:border-0 bg-white"
      onMouseEnter={() => { setHovered(true); setIsOpen(true); }}
      onMouseLeave={() => { setHovered(false); setIsOpen(false); }}
    >
      <div
        className="py-6 px-4 hover:bg-gray-50 transition-colors group flex flex-col md:flex-row gap-4 items-start md:items-center justify-between"
      >
        <div className="flex items-center gap-4">
          <motion.div
            animate={{ rotate: isOpen ? 90 : 0 }}
            className={`p-2 rounded-full transition-colors ${isOpen ? 'bg-nothing-red text-white' : 'bg-gray-100 text-gray-400 group-hover:bg-gray-200'}`}
          >
            <ChevronRight size={16} />
          </motion.div>
          <div>
            <h3 className="font-bold text-lg text-ink">{data.company}</h3>
            <p className="text-sm text-gray-600 font-mono">{data.role}</p>
          </div>
        </div>
        <div className="flex flex-col md:items-end gap-1">
          <span className="font-ndot text-sm text-gray-500">{data.time}</span>
          <span className="text-xs font-mono text-gray-500 flex items-center gap-1"><MapPin size={10} /> {data.location}</span>
        </div>
      </div>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="overflow-hidden bg-gray-50/50"
          >
            <div className="p-6 pl-16 grid grid-cols-1 md:grid-cols-3 gap-8 border-t border-gray-100">
              <div className="md:col-span-2 space-y-3">
                {data.details.map((detail, i) => (
                  <motion.div
                    key={i}
                    initial={{ x: -10, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ delay: i * 0.1 }}
                    className="flex gap-3 text-sm text-gray-600 font-mono leading-relaxed"
                  >
                    <span className="text-nothing-red">{`>`}</span>
                    {detail}
                  </motion.div>
                ))}
              </div>
              <div>
                <h4 className="text-xs font-bold uppercase tracking-widest text-gray-400 mb-3">Tech Stack</h4>
                <div className="flex flex-wrap gap-2">
                  {data.tech.map(t => (
                    <span key={t} className="px-2 py-1 bg-white border border-gray-200 text-xs font-medium rounded text-gray-600">
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};